<!--
/**
 * @name 'record'
 * @desc ''
 * @author ''
 * @time 2022年05月07日 10:20:41 星期六
 */
-->
<template>
  <div>
    <div class="record1"></div>
    <div class="record2">
      <el-form ref="added" inline size="medium">
        <el-form-item label="服务对象名称">
          <el-input @keyup.enter.native="search" v-model="query.customer_name_or_phone" placeholder="请输入服务对象名称或手机号"
            clearable show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="服务人员">
          <el-input @keyup.enter.native="search" v-model="query.founders_name_or_phone" placeholder="服务人员名称或手机号"
            clearable show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="服务状态">
          <el-select v-model="query.service_status" placeholder="请选择状态" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="服务中" :value="1"></el-option>
            <el-option label="已结束" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务时间">
          <!-- <el-select v-model="query.add_date" placeholder="请选择" style="width: 120px;">
            <el-option :label="date" :value="date" v-for="date in DateList" :key="date"></el-option>
          </el-select>
          -->
          <el-date-picker style="width: 160px;" v-model="query.add_date" type="month" value-format="yyyy-MM"
            :clearable='true' placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="query.service_audit_status" placeholder="请选择状态" clearable>
            <el-option :label="state.label" v-for="(state,i) in states" :key='i' :value="state.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div></div>
        <el-form-item label="区域">
          <el-cascader v-model="query.code" ref="area" :options="areaList" clearable popper-class='myArea' :props="{
          expandTrigger: 'hover',
          children: 'child',
          label:'area_name',
          value:'area_code',
          checkStrictly: true
        }" @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item label="评价星级">
          <el-select v-model="query.comment_level" placeholder="请选择评价星级" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="一星" :value="1"></el-option>
            <el-option label="二星" :value="2"></el-option>
            <el-option label="三星" :value="3"></el-option>
            <el-option label="四星" :value="4"></el-option>
            <el-option label="五星" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务类目">
          <el-cascader v-model="query.value" ref='pro' :options="projectList" popper-class='myArea' clearable :props="{
            expandTrigger: 'hover',
            children: 'child',
            label: 'service_project_name',
            value: 'service_project_id',
            checkStrictly: true
          }" @change="handleCategoryChange"></el-cascader>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'record/query')">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'record/reset')">
          <el-button type="info" icon="el-icon-refresh-right" @click="reset"> 重置 </el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'record/export')">
          <el-button :disabled="!list.length" type="warning" icon="el-icon-upload" @click="handleExport">导出
          </el-button>
        </el-form-item>
        <!-- <el-form-item v-if="JudgeButton(role_permission,'record/export')">
          <el-button v-loading='downloading' :disabled="!list.length" type="warning" icon="el-icon-printer" @click="printting">智能打印
          </el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="record3">
      <el-table v-loading='loading' stripe border :data="list" tooltip-effect="dark" style="width: 98%">
        <el-table-column align='center' prop="customer_name" label="服务对象名称">
        </el-table-column>
        <el-table-column align='center' prop='service_start_time' label="服务日期">
        </el-table-column>
        <el-table-column align='center' prop="service_category_name" label="服务类目">
        </el-table-column>

        <el-table-column align='center' prop="service_project_name" label="服务项目">
        </el-table-column>

        <el-table-column align='center' label="服务评价" width="180">
          <template slot-scope="scope">
            <el-rate disabled v-model="scope.row.service_comment_level"></el-rate>
          </template>
        </el-table-column>

        <el-table-column align='center' label="服务状态">
          <template slot-scope="scope">
            <span v-if="scope.row.service_status == 1">服务中</span>
            <span v-if="scope.row.service_status == 2">已结束</span>
          </template>
        </el-table-column>

        <el-table-column align='center' label="审核状态">
          <template slot-scope="scope">
            {{ states[scope.row.service_audit_status+1].label }}
          </template>
        </el-table-column>
        <el-table-column align='center' prop="nurse_user_name" label="服务人员">
        </el-table-column>

        <el-table-column align='center' prop="sign_area_name" label="区域">
        </el-table-column>

        <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <el-button v-if="JudgeButton(role_permission,'record/details')" size="mini" type="primary"
              @click="detailsReset(scope.row)">详情</el-button>
            <el-button v-if="JudgeButton(role_permission,'record/delete')" size="mini"
              :disabled='scope.row.service_comment_status !== 1' type="danger" @click="handleDelete(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="query.total">
      </el-pagination>
    </div>
    <print ref='print' :list='list' :title="printTitle"></print>
  </div>
</template>
<script>
  import userInfoAPI from '@/api/api';
  import print from './components/printDialog.vue';
  var that;
  const year = new Date().getFullYear();
  const month = new Date().getMonth() + 1 < 10 ?
    "0" + (new Date().getMonth() + 1) :
    new Date().getMonth() + 1;
  export default {
    components: {
      print
    },
    props: {},
    data() {
      return {
        downloading: false,
        loading: true,
        states: [{
            label: '全部',
            value: ''
          },
          {
            label: '未审核',
            value: 0
          },
          {
            label: '合格',
            value: 1
          },
          {
            label: '不合格',
            value: 2
          },
          {
            label: '终审不合格',
            value: 3
          },
          {
            label: '预审合格',
            value: 4
          },
        ],
        query: {
          customer_name_or_phone: '',
          founders_name_or_phone: '',
          service_status: '',
          service_audit_status: '',
          comment_level: '',
          page_limit: 10,
          page: 1,
          flag: '', // 操作标志 export=数据导出
          total: 0,
          add_date: '全部',
          code: '',
          area_code: '',
          village_code: '',
          service_category_id: '',
          service_project_id: '',
          value: ''
        },
        list: [],
        DateList: ['全部'],
        areaList: [],
        projectList: [],
        printTitle: '',
        defaultValue: year + '-' + month
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    watch: {},
    created() {
      that = this;
      if (this.$store.state.cache.cacheRecordQuery) this.query = this.$store.state.cache.cacheRecordQuery
      this.query.flag = ''
      this.getDateList()
    },
    beforeDestroy() {
      this.$store.commit('CACHE_RECORD', this.query)
    },
    methods: {
      getProjectList() {
        userInfoAPI.serviceProjectList({
          category_id: '',
          project_name: '',
          page_limit: 999,
          page: 1,
          project_status: '',
          flag: 'child'
        }).then(res => {
          if (res.data) {
            this.projectList = res.data.data || []
            this.projectList.forEach(item => {
              item.service_project_name = item.service_category_name
              item.service_project_id = item.service_category_id
            })
            this.projectList = [].concat(this.projectList)
          }
        })
      },
      getAreaList() {
        userInfoAPI.systemSelectionList().then(({
          data
        }) => {
          if (data.code == 0) {
            this.areaList = data.data;
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            })
          }
        })
      },
      handleChange(e) {
        if (e[0]) {
          this.query.area_code = e[0]
          this.query.village_code = e[1] || ''
          if(e[1]){
            that.$refs.area.dropDownVisible = false
          }
        } else {
          this.query.area_code = ''
          this.query.village_code = ''
        }
      },
      handleCategoryChange(e) {
        if (e[0]) {
          this.query.service_category_id = e[0]
          this.query.service_project_id = e[1] || ''
          if(e[1]){
            that.$refs.pro.dropDownVisible = false
          }
        } else {
          this.query.service_category_id = ''
          this.query.service_project_id = ''
        }
      },
      async getDateList() {
        // await userInfoAPI.getDateList().then((res) => {
        //   if (res.data.code == 0) {
        //     res.data.data = res.data.data || []
        //     this.DateList = this.DateList.concat(res.data.data)
        //     // this.query.add_date = res.data.data[0]
        //   }
        // })
        await this.getProjectList()
        await this.getList()
        await this.getAreaList()
      },
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      submitForm() {
        this.$refs['added'].validate(valid => {
          if (!valid) return
          // TODO 提交表单
        })
      },
      handleExport() {
        this.query.flag = 'export';
        this.getList();
      },
      search() {
        this.loading = true;
        this.query.flag = '';
        this.query.page = 1;
        this.list = [];
        this.getList()
      },
      handleDelete(row) { //删除
        this.$confirm('此操作将永久删除该记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceLogDel({
            service_log_id: row.service_log_id
          }).then(res => {
            if (res.data.code == 0) {
              this.$message.success(res.data.msg)
              this.getList()
            }
          })
        })
      },
      detailsReset(row) { //详情
        this.$router.push({
          name: 'details',
          query: {
            id: row.service_log_id,
            date: this.query.add_date == '全部' ? '' : this.query.add_date
          }
        })
      },
      getList() {
        this.loading = true
        this.query.add_date
        let query = JSON.parse(JSON.stringify(this.query))
        if (query.add_date == '全部') query.add_date = ''
        userInfoAPI.serviceLogList(query).then(res => {
          if (this.query.flag == 'export') {
            let blob = new Blob([res.data], {
              type: 'application/vnd.ms-excel'
            })
            let objectUrl = URL.createObjectURL(blob)
            let link = document.createElement('a')
            link.href = objectUrl
            link.setAttribute('download', '服务记录列表')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(objectUrl)
          } else {
            if (res && res.data.code == 0) {
              this.list = res.data.data.list || []
              this.query.total = res.data.data.page.count || 0
            }
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.query.flag = '';
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.flag = '';
        this.query.page = val;
        this.getList();
      },
      reset() {
        this.query.customer_name_or_phone = ''
        this.query.founders_name_or_phone = ''
        this.query.service_status = ''
        this.query.service_audit_status = ''
        this.query.comment_level = ''
        this.query.code = ''
        this.query.area_code = ''
        this.query.village_code = ''
        this.query.add_date = ''
        this.query.service_project_id = ''
        this.query.service_category_id = ''
        this.query.value = ''
      },
      printting(){
        let area = '', areaObj = '', date = '';
        if(this.query.area_code){
          areaObj = this.areaList.find(i=>i.area_code == this.query.area_code)
          area = areaObj.area_name
        }
        if(this.query.village_code){
          area += '/'+areaObj.child.find(k=>k.area_code == this.query.village_code).area_name
        }
        if(this.query.add_date && this.query.add_date !== '全部'){
          date = this.query.add_date.replace('-','年') + '月'
        }
        this.printTitle = date + area + '服务记录列表'
        this.downloading=true;
        // this.$refs.print.download()
        setTimeout(()=>{
          this.downloading=false;
        },2000)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .record1 {
    height: 20px;
  }

  .record3 {
    margin-left: 20px;
  }

  .record2 .el-form-item {
    margin-left: 20px;
  }
</style>
